// extracted by mini-css-extract-plugin
export default {"import":"FullPrivacy_import__VeBiM","importButton":"FullPrivacy_importButton__ygMNR"};